<template>
	<v-flex> 
	<!-- :height="$vuetify.breakpoint.width > 1920 ? '850' : '510' "    -->       
		<v-card class="pb-4" :class="roomBucket ? 'roomgridcardRV' : 'roomgridcard'" >
			<v-toolbar flat class="filters">
				<v-toolbar-title>ROOMS</v-toolbar-title>

				<v-layout justify-space-around mt-3 >
					<v-flex>
						<v-layout row>
							<v-btn v-if="isSuperUser" icon @click="createNewRoom(building)">
								<v-icon color="grey darken-2">add_circle_outline</v-icon>
							</v-btn>					
							<v-btn icon @click="exportTable">
								<v-tooltip left><v-icon slot="activator" color="grey darken-2">save_alt</v-icon>
								<span>Export to Excel</span>
							</v-tooltip>
							</v-btn>
						</v-layout>
					</v-flex>
					<v-flex px-3>
			            <v-autocomplete 
							@change="addFloorFilter"
			                autocomplete				                
			                clearable         
			                :items="floors"
			                label="Floor">
			            </v-autocomplete>
					</v-flex>
					<v-flex px-3>
						<v-autocomplete
							@change="addDeptFilter"
							v-model="autocompleteDeptSelected"
			                autocomplete				                
			                clearable
			                :items="depts"
			                label="Dept">
			            </v-autocomplete>
			        </v-flex>
			        <v-flex px-3>
			            <v-autocomplete
							@change="addCollegeFilter"
							v-model="autocompleteCollegeSelected"
			                autocomplete				                
			                clearable
			                :items="colleges"
			                label="College">
			            </v-autocomplete>
					</v-flex>						
					<v-flex px-3>
			            <v-autocomplete
							@change="addCategoryFilter"
			                autocomplete				                
			                clearable         
			                style=""
			                :items="categories"
			                label="Category">
			            </v-autocomplete>
					</v-flex>
					<v-flex px-3>
			            <v-autocomplete
							@change="addUseFilter"
			                autocomplete				                
			                clearable         
			                style=""
			                :items="uses"
			                label="Use">
			            </v-autocomplete>
					</v-flex>
					<v-flex px-3>
			            <v-autocomplete
							@change="addClassificationFilter"
			                autocomplete				                
			                clearable         
			                style=""
			                :items="classifications"
			                label="Classification">
			            </v-autocomplete>
					</v-flex>
				</v-layout>
			</v-toolbar>
			<v-card v-if="rooms && rooms.length > paginationThreshold " class="pl-2" elevation="2" >
		  		<v-layout row align-center justify-space-between>
		  			<v-flex>
		  				<v-btn small icon>
				  			<v-icon @click="decrementPagination" color="grey darken-3">
				  				keyboard_arrow_left
				  			</v-icon>
				  		</v-btn>
				  		{{this.currentIndex + 1}} - {{this.endIndex}} 
				  		<v-btn small icon>
				  			<v-icon @click="incrementPagination" color="grey darken-3">
				  				keyboard_arrow_right
				  			</v-icon>
				  		</v-btn>
				  		<span v-if="rooms.length">of {{filteredItems.length}}</span>
			  		</v-flex>
			  		<v-flex xs1 class="pointer mr-4 redlink text-xs-right" @click="showAll">Show All</v-flex>
			  	</v-layout>
		  		
	  		</v-card>
			<v-data-table
				class="roomgrid"
				:style="items.length > paginationThreshold ? 'position: relative; top: -10px;' : ''"
				v-model="selected"
				select-all
				item-key="key" 
				@input="updateSelected"
				:headers="headers" 
				:items="items" 
				:loading="loading || !rooms || rooms.length==0"
				hide-actions
				:total-items="disableSort"
				>
				<template v-slot:items="props">
					<tr @click="getRoom(props.item)" style="height: 10px; !important;"
						:id="props.item.key" :active="props.selected" >
					 	<td>
							<v-checkbox @click.stop="props.selected = !props.selected" 
								hide-details
								color="primary"
								:input-value="props.selected">									
							</v-checkbox>
						</td>
						<td :class="{ 'text-xs-right' : header.align == 'right' }"
							class="caption" v-for="(header, index) in headers" v-bind:key="index">
							{{ getColumnData(props.item, header) }}
						</td>
						<td>
							<v-tooltip left>
								<v-icon slot="activator" @click.stop="showRoomOnMap(props.item)">near_me</v-icon>
								<span>Show on Map</span>
							</v-tooltip>
						</td>
					</tr>
				</template>
 				<template slot="footer" >  
 						<td class="caption">Count: {{items.length}}</td>
						<td v-for="(header, index) in headers" class="caption text-xs-right" v-bind:key="index" >
							<div v-if="header.value == 'calcArea'">{{ sumCalc(header.value) }}</div>
							<div v-if="header.value == 'area'">{{ sumCalc(header.value) }}</div>
						</td>
				</template>
				<template v-slot:no-data>
			      <v-layout justify-center>Loading...</v-layout>
			    </template>
			</v-data-table>

		</v-card>
	</v-flex>

</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions } from 'vuex'
import XLSX from 'xlsx'

export default {
name: 'RoomGrid',
data () {
	return {
		checkbox: false,
		disableSort: undefined,
		selected: [],
		loading: false,
		autocompleteDeptSelected: null,
		autocompleteCollegeSelected: null,
		filters:  [ 
						{ property: 'floor', 	value: null },
						{ property: 'deptName', value: null },
						{ property: 'collegeName', value: null },
						{ property: 'categoryName', value: null },
						{ property: 'useName', value: null },
						{ property: 'classification', value: null },
			 		],
		
    	currentIndex: 0,
    	numberOfItemsToShow: 1000,
    	paginationThreshold: 1000,  // Check below, this is in two places
	}
},

created: function () {
	

},

watch: {

		multiSelectRoomArray (val) {
			//console.log("Change Detected", val)
			if (val.length == 0) { this.selected = [] }
		},

		rooms (val) {
			// Reset some things
			this.filters.forEach((filter) => { filter.value = null })
			this.currentIndex = 0
			this.paginationThreshold = 1000

			// Warn on large data sets, adjust disbleSort
			if (this.rooms && (this.rooms.length > this.paginationThreshold)) {
			this.disableSort = 100000	//This will disable sort during pagination
			this.setSnackText("Large dataset will be paginated.  Sorting disabled")
			} else { 
				this.disableSort = undefined; // this will enable sort
			}
		}
	},

computed: {
	...mapState({  	building: state => state.dv.building,
					buildingRooms: state => state.dv.buildingRooms,
					room: state => state.dv.room,
					isSuperUser: state => state.user.isSuperUser,
					showDVBulkEdit: state => state.dv.showDVBulkEdit,
					multiSelectRoomArray: state => state.ui.multiSelectRoomArray,
					roomBucket: state => state.roomViewer.roomBucket,
					bucketType: state => state.roomViewer.bucketType,
				}),

	rooms: function () {
		// This little code ensures backward compatibility with the bldgviewer which works off of buildingRooms
		if (this.roomBucket) { return this.roomBucket }
		else { return this.buildingRooms }
	},

	showOccupantsPIs: function () {
		// If there is a PCT record, than we are showing occupants and PIs
		return this.roomBucket && this.roomBucket[0] && this.roomBucket[0].PCT
	},

	headers () {
	      if(!this.showOccupantsPIs){
	        return this.dynamicHeaders.filter(header => header.text !== "Occupant" && header.text !== "PI" && header.text !== "User Dept" && header.text !== "Program")
	      }	      
	      return this.dynamicHeaders
	    },

	dynamicHeaders: function () {
		let returnHeaders = []
		if (this.bucketType == 'building' || !this.bucketType) {
			returnHeaders =  [	
					{ text: 'Number',           value: 'number',         class: 'column',        },
					{ text: 'Floor',            value: 'floor',          class: 'column',        },
					{ text: 'Occupant',         value: 'occupant',       class: 'column',        },
					{ text: 'PI',               value: 'PI',             class: 'column',        }, 
					{ text: 'Program',         value: 'program',       class: 'column',        },
					{ text: 'College ID',       value: 'collegeID',      class: 'column',        },
					{ text: 'College Name',     value: 'collegeName',    class: 'column',        },
					{ text: 'Dept ID',          value: 'deptID',         class: 'column',        },
					{ text: 'Dept Name',        value: 'deptName',     	 class: 'column',        },
					{ text: 'User Dept',		value: 'userDeptName', 		 class: 'column', 		 }, 
					{ text: 'Type',         	value: 'type',       class: 'column',        },
					{ text: 'Type Name',    	value: 'typeName',   class: 'column',        },
					{ text: 'Use',              value: 'use',            class: 'column',        },
					{ text: 'Use Name',         value: 'useName',        class: 'column',        },
					{ text: 'Classification',   value: 'classification', class: 'column',        },
					//{ text: 'Restricted',       value: 'restricted',     class: 'column',        },
					{ text: 'Share',             value: 'calcArea',           class: 'column',   align: 'right', total: true        },
					{ text: 'Area',             value: 'area',           class: 'column',   align: 'right', total: true        },
    		]
    	} 

    	if (this.bucketType == 'department') {
    		returnHeaders =	[
    				{ text: 'Building',         value: 'bldgAlpha',         class: 'column',        },
					{ text: 'Name',         	value: 'bldgName',         class: 'column',        },
					{ text: 'Number',           value: 'number',         class: 'column',        },
					{ text: 'Floor',            value: 'floor',          class: 'column',        },
					{ text: 'Occupant',         value: 'occupant',       class: 'column',        },
					{ text: 'PI',               value: 'PI',             class: 'column',        }, 
					{ text: 'User Dept',		value: 'userDeptName', 		 class: 'column', 		 }, 
					{ text: 'Type',         	value: 'type',       class: 'column',        },
					{ text: 'Type Name',    	value: 'typeName',   class: 'column',        },
					{ text: 'Use',              value: 'use',            class: 'column',        },
					{ text: 'Use Name',         value: 'useName',        class: 'column',        },
					{ text: 'Classification',   value: 'classification', class: 'column',        },
					//{ text: 'Restricted',       value: 'restricted',     class: 'column',        },

					{ text: 'Area',             value: 'area',           class: 'column',   align: 'right', total: true        },
			]
		}

		if (this.bucketType == 'college') {
    		returnHeaders =	[
    				{ text: 'Building',         value: 'bldgAlpha',         class: 'column',        },
					{ text: 'Name',         	value: 'bldgName',         class: 'column',        },
					{ text: 'Number',           value: 'number',         class: 'column',        },
					{ text: 'Floor',            value: 'floor',          class: 'column',        },
					{ text: 'Occupant',         value: 'occupant',       class: 'column',        },
					{ text: 'PI',               value: 'PI',             class: 'column',        }, 
					{ text: 'Dept ID',          value: 'deptID',         class: 'column',        },
					{ text: 'Dept Name',        value: 'deptName',     	 class: 'column',        },
					{ text: 'User Dept',		value: 'userDeptName', 		 class: 'column', 		 }, 
					{ text: 'Type',         	value: 'type',       class: 'column',        },
					{ text: 'Type Name',    	value: 'typeName',   class: 'column',        },
					{ text: 'Use',              value: 'use',            class: 'column',        },
					{ text: 'Use Name',         value: 'useName',        class: 'column',        },
					{ text: 'Classification',   value: 'classification', class: 'column',        },
					//{ text: 'Restricted',       value: 'restricted',     class: 'column',        },
					{ text: 'Area',             value: 'area',           class: 'column',   align: 'right', total: true        },
			]
		}

		// Remove calcArea if not selecting College or Dept
      	if(!this.autocompleteDeptSelected && !this.autocompleteCollegeSelected ){
        	returnHeaders = returnHeaders.filter(header => header.text !== "Share")
      	}

		return returnHeaders
	},

	items: function () {
		if (this.rooms && (this.rooms.length > this.paginationThreshold)) {
  				return this.filteredItems.slice(this.currentIndex, this.endIndex) // Slice does NOT include the end index item
  			} else { 
  				return this.filteredItems;  
  			}
	},

	filteredItems: function () { 
  			
  			let returnitems = this.rooms ? this.rooms : [] 
  			
  			// Initialize a calcArea property
  			returnitems.forEach((room) => { room.calcArea = 0 })

  			// If PCT exists (rooms-full endpoint), copy it to departments so the rest of this code works.
  			returnitems.forEach((room) => { if (room.PCT) { room.departments = room.PCT }})

  			this.filters.forEach((filter) => {

            	// For Dept, prefilter by the rmpct level of departments, then successively filter rooms by the remaining filters
            	// Push any room with assigned space for this dept into a new array
				if (filter.value && (filter.property == "deptName" || filter.property == "collegeName")) {
					let preFilteredItems = []					
					returnitems.forEach((room) => {
						room.departments.forEach((dept) => {
							if (dept.deptName == this.autocompleteDeptSelected) {
								// Same dept can be represented twice, so += them.  
								// Replace whats in the array if its found. (Deduplicates and updates)
								room.calcArea += room.area * dept.percentage/100
								let foundRoom = preFilteredItems.find((pfRoom) => { return pfRoom.key == room.key })
								if (foundRoom) {
									foundRoom = room
								} else {
									preFilteredItems.push(room)
								}
							}
							if (dept.collegeName == this.autocompleteCollegeSelected) {
								// College could have several departments, so += them.  
								// Replace whats in the array if its found. (Deduplicates and updates)
								room.calcArea += room.area * dept.percentage/100
								let foundRoom = preFilteredItems.find((pfRoom) => { return pfRoom.key == room.key })
								if (foundRoom) {
									foundRoom = room
								} else {
									preFilteredItems.push(room)
								}
							}
						})
					})

	                // Replace returnitems with the preFiltered Array
	                returnitems = preFilteredItems
				}



				// Successive Filtering for each remaining filterterm.
                if (filter.value && filter.property != "deptName" && filter.property != "collegeName") {
                	returnitems = returnitems.filter((item) => item[`${filter.property}`] == filter.value )
                }
            })

  			return returnitems
  		},

  	endIndex () {
    	let end = this.currentIndex + this.numberOfItemsToShow
    	return end + 1 > this.filteredItems.length ? this.filteredItems.length : end
    },

    depts: function () {
		const items = this.filteredItems.map((room) => { return room.deptName })
		return items.filter((item) => item != null).sort()

	},
	colleges: function () {
		const items = this.filteredItems.map((room) => { if (room.collegeName) { return room.collegeName}})
		return items.filter((item) => item != null).sort()
	},
	floors: function () {
		const items = this.filteredItems.map((room) => { if (room.floor) { return room.floor}})
		return items.filter((item) => item != null).sort()
	},
	categories: function () {
		const items = this.filteredItems.map((room) => { if (room.categoryName) { return room.categoryName}})
		return items.filter((item) => item != null).sort()
	},
	uses: function () {
		const items = this.filteredItems.map((room) => { if (room.useName) { return room.useName}})
		return items.filter((item) => item != null).sort()
	},
	classifications: function () {
		const items = this.filteredItems.map((room) => { if (room.classification) { return room.classification}})
		return items.filter((item) => item != null).sort()
	},
},

methods : {
	...mapMutations([ 	'setBuildings', 'createNewRoom', 'setMultiSelectRoomArray',
						'setShowDVBulkEdit', 'updateBulkRoomEditSideBar',
						'setCurrentDept', 'setSnackText',
	]),

	...mapActions([		'fetchFullRoom', 'setRoom',
	]),

	sumCalc: function (headerValue) {
				let sum = 0;        
				this.items && this.items.map((room) => { sum += room[headerValue] })
				return sum && sum.toLocaleString(undefined, { maximumFractionDigits: 0 })
	},

	updateSelected: function (value) {
		this.setMultiSelectRoomArray(value)
		this.setRoom(null)
		if (value.length > 0 )  { this.setShowDVBulkEdit(true)  }
		else 					{ this.setShowDVBulkEdit(false) }
	},

	getRoom: function (item) {
		this.setRvRoute(item)
		this.loading = true
		this.fetchFullRoom({bldgAlpha: item.bldgAlpha, number: item.number, noSet: true}).then((data) => { 
			this.setRoom(data) 
			this.loading = false
		})
	},

	setRvRoute(room) {  // This just sets route		
		console.log("Updating Route with Room ", { name: 'RoomViewerToBldgRoom', params: { rvbldg: room.bldgAlpha, rvroom: room.number }})
		this.$router.push({
			name: "RoomViewerToBldgRoom",
			params: { rvbldg: room.bldgAlpha, rvroom: room.number }
		})
	},

	getColumnData: function (item, header) {
			//console.log(header.value)
			if (header.value == "PI") {
				let PIs = []

					item.PCT.map((pct) => {
						pct.PI.map((PI) => {
							PIs.push(PI.name + " " + PI.title)
						}) 						
					})
				return PIs.join(", ") 
			
			} else if (header.value == "occupant") {
				let occupants = []

					item.PCT.map((pct) => {
						pct.occupant.map((occupant) => {
							occupants.push(occupant.name + " - " + occupant.title)
						}) 						
					})
				return occupants.join(", ") 

			} else if (header.value == "userDeptName") {
				let userDepts = []
					item.PCT && item.PCT.map((pct) => {
						pct.userDeptID && userDepts.push(pct.userDeptID + "-" + pct.userDeptName)
					})
				return userDepts.join(", ")
			
			} else if (item[header.value]) {
				if ( header.align == "right") {  
					return item[header.value].toLocaleString(undefined, { maximumFractionDigits: 0 })
				} else {
					return item[header.value]
				}
			} else if (header.value == "program") {
				let programs = []
					item.PCT.map((pct) => {
						pct.program.map((program) => {
							programs.push(program.description)
						}) 						
					})
				return programs.join(", ")
			
			}
		},

	addDeptFilter: function (value) {
			this.addFilter("deptName", value)
	},

	addCollegeFilter: function (value) {
		this.addFilter("collegeName", value)			
	},

	addCategoryFilter: function (value) {
		this.addFilter("categoryName", value)			
	},

	addFloorFilter: function (value) {
		this.addFilter("floor", value)			
	},

	addUseFilter: function (value) {
		this.addFilter("useName", value)			
	},

	addClassificationFilter: function (value) {
		this.addFilter("classification", value)			
	},

	addFilter: function (property, value) {
		if (property == "deptName") {				
			const index = this.filters.findIndex(filter => filter.property=="collegeName")
			this.filters[index].value = null
			this.autocompleteCollegeSelected = null 
		}

		if (property == "collegeName") {				
			const index = this.filters.findIndex(filter => filter.property=="deptName")
			this.filters[index].value = null
			this.autocompleteDeptSelected = null 
		}
		const index = this.filters.findIndex(filter => filter.property==property)
		this.filters[index].value = value
		//console.log(this.filters)
		// Reset item index so we start over listing the beginning
		this.currentIndex = 0
	},

	incrementPagination: function () {
		if (this.currentIndex + this.numberOfItemsToShow > this.filteredItems.length) { return }
		this.currentIndex += this.numberOfItemsToShow

	},

	decrementPagination: function () {
		this.currentIndex -= this.numberOfItemsToShow
		if (this.currentIndex < 0) { this.currentIndex = 0}
	},

	showAll: function () {
		this.setSnackText("Loading all rooms.  Performance may be degraded. ")
		setTimeout( () => { this.paginationThreshold = 100000 }, 300);
	},

	showRoomOnMap: function(room) {
		console.log("Show on Map", room.bldgAlpha, room.number)
		var win = window.open("https://interactivefloorplans.arizona.edu/"  + room.bldgAlpha + "/" + room.number, '_blank', 
			'location=yes,height=900,width=1500,,status=yes');
  		win.focus();
		
	},

	
	getExcelHeader: function () {
		if(this.bucketType == 'building' || !this.bucketType) {
			return "Room Viewer - By Building"
		}
		else if (this.bucketType == 'department' ) {
			return "Room Viewer - By Department"
		}
		else {
			return "Room Viewer - By College"
		}
	},

	exportTable: function () {
	      	// Create workbook
	      	const wb = XLSX.utils.book_new() 

	      	// Create worksheet, and add info
	      	let ws = XLSX.utils.aoa_to_sheet([
						[this.getExcelHeader()]
					])

			// Column Widths
			var wscols = [];

			var exportType = ""

	      	let roomData = this.items.map((room) => {

				if (this.bucketType == 'building' || !this.bucketType) {
					
					exportType = room.bldgName

					if(this.showOccupantsPIs) {
						// Column Widths
						wscols = [
							{wch:10},
							{wch:10},
							{wch:40},
							{wch:40},
							{wch:30},
							{wch:40},
							{wch:40},
							{wch:20},
							{wch:10},
							{wch:20},
							{wch:10},
							{wch:20},
							{wch:20},
							{wch:10},
							
						];
						return 	{	Number: room.number,
			  						Floor: room.floor,
									Occupant: this.getColumnData(room, {value: 'occupant'}),
									PI: this.getColumnData(room, {value: 'PI'}),
									Program: this.getColumnData(room, {value: 'program'}),
			  						College: `${room.collegeName} (${room.collegeID})`,
			  						Dept: `${room.deptName} (${room.deptID})`,
									UserDept: this.getColumnData(room, {value: 'userDeptName'}),
			  						Type: room.type,
									TypeName: room.typeName,
									Use: room.use,
			  						UseName: room.useName,
									Classification: room.classification,
			  						Area: room.area, 

		  				}
					} else {
						// Column Widths
						wscols = [
							{wch:10},
							{wch:10},
							{wch:40},
							{wch:40},
							{wch:10},
							{wch:20},
							{wch:10},
							{wch:20},
							{wch:20},
							{wch:10},
							
							
						];
						return 	{	Number: room.number,
			  						Floor: room.floor,
			  						College: `${room.collegeName} (${room.collegeID})`,
			  						Dept: `${room.deptName} (${room.deptID})`,
			  						Type: room.type,
									TypeName: room.typeName,
									Use: room.use,
			  						UseName: room.useName,
									Classification: room.classification,
			  						Area: room.area, 
		  				}
					}
						
				}

				if (this.bucketType == 'department') {

					exportType = room.deptName

					if(this.showOccupantsPIs) {
						// Column Widths
						wscols = [
							{wch:10},
							{wch:30},
							{wch:10},
							{wch:10},
							{wch:40},
							{wch:40},
							{wch:20},
							{wch:20},
							{wch:10},
							{wch:10},
							{wch:20},
							{wch:10},
							{wch:10},
							
						];
						return 	{	Building: room.bldgAlpha,
									Name: room.bldgName,
									Number: room.number,
			  						Floor: room.floor,
									Occupant: this.getColumnData(room, {value: 'occupant'}),
									PI: this.getColumnData(room, {value: 'PI'}),
									UserDept: this.getColumnData(room, {value: 'userDeptName'}),
									Type: room.type,
									TypeName: room.typeName,
									Use: room.use,
			  						UseName: room.useName,
									Classification: room.classification,
			  						Area: room.area, 
		  				}
					}
					else {
					// Column Widths
						wscols = [
							{wch:10},
							{wch:30},
							{wch:10},
							{wch:10},
							{wch:20},
							{wch:20},
							{wch:10},
							{wch:20},
							{wch:10},
							{wch:10},
							
						];
						return 	{	Building: room.bldgAlpha,
									Name: room.bldgName,
									Number: room.number,
			  						Floor: room.floor,
			  						Type: room.type,
									TypeName: room.typeName,
									Use: room.use,
			  						UseName: room.useName,
									Classification: room.classification,
			  						Area: room.area, 
		  				}
					}

				}

				if (this.bucketType == 'college') {

					exportType = room.collegeName

					if(this.showOccupantsPIs) {
						// Column Widths
						wscols = [
							{wch:10},
							{wch:30},
							{wch:10},
							{wch:10},
							{wch:40},
							{wch:40},
							{wch:40},
							{wch:20},
							{wch:20},
							{wch:10},
							{wch:10},
							{wch:20},
							{wch:10},
							{wch:10},
							
						];
						return 	{	Building: room.bldgAlpha,
									Name: room.bldgName,
									Number: room.number,
			  						Floor: room.floor,
									Occupant: this.getColumnData(room, {value: 'occupant'}),
									PI: this.getColumnData(room, {value: 'PI'}),
									Dept: `${room.deptName} (${room.deptID})`,
									UserDept: this.getColumnData(room, {value: 'userDeptName'}),
			  						Type: room.type,
									TypeName: room.typeName,
									Use: room.use,
			  						UseName: room.useName,
									Classification: room.classification,
			  						Area: room.area, 
		  				}
					}
					else {
						// Column Widths
						wscols = [
							{wch:10},
							{wch:30},
							{wch:10},
							{wch:10},
							{wch:40},
							{wch:20},
							{wch:10},
							{wch:10},
							{wch:20},
							{wch:10},
							{wch:10},
							
						];
						return 	{	Building: room.bldgAlpha,
									Name: room.bldgName,
									Number: room.number,
			  						Floor: room.floor,
									Dept: `${room.deptName} (${room.deptID})`,
			  						Type: room.type,
									TypeName: room.typeName,
									Use: room.use,
			  						UseName: room.useName,
									Classification: room.classification,
			  						Area: room.area, 
		  				}

					}
				}

      				
		  		
	      	})

	      	
	      	XLSX.utils.sheet_add_json(ws, roomData, {origin:"A3"})

			ws['!cols'] = wscols;
	      
	      	// add Worksheet to Workbook
			XLSX.utils.book_append_sheet(wb, ws, `Room Table`)

	      	// export Excel file
	      	XLSX.writeFile(wb, "Room Export " + exportType + ".xlsx") // name of the file is 'book.xlsx'   

	    },
	},
}

</script>

<style>

.filters .v-label  {
	font-size: 14px !important;

}

.roomgridcard {
	height: calc(100vh - 440px);
}

.roomgridcardRV {
	height: calc(100vh - 180px);
}

.roomgrid {
		height: calc(100% - 70px);
		overflow-y: auto;
}

/* this technique gets deeply nested th td selectors */
.roomgrid th { padding-left: 5px !important; }
.roomgrid th :first-child { padding-left: 5px !important; }
.roomgrid td { padding-left: 5px !important; height: 10px !important;}
.roomgrid td :first-child { padding-left: 5px !important; height: 10px !important;}
.roomgrid .v-table__overflow { 
	overflow-x: unset !important;
	overflow-y: unset !important;
 }

 .roomgrid .table {
 	padding-left: 30px;
 	border-radius: 0px;
 }

/* table.v-table thead th:first-child {
 	padding: 0 0 0 24px !important;
 }*/

.roomgrid .v-input--selection-controls__input {
 	margin-right: 0px;
 }

 .pointer {
	cursor: pointer !important;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomGrid.vue